import { Gesture } from "./Gesture";
import { localPlayerContainer } from "../localplayer/LocalPlayerContainer";
import { GestureType } from "flavr-common";
export class GrabRotateGesture extends Gesture {
    constructor(gestureModule, twoHandedGuestureView) {
        super(GestureType.GrabRotate, true);
        this.gestureModule = gestureModule;
        this.twoHandedGuestureView = twoHandedGuestureView;
    }
    begin() {
        this.twoHandedGuestureView.onBeginRotation();
    }
    update() {
        const data = this.gestureModule.currData;
        const prevData = this.gestureModule.prevData;
        if (data.primaryController && data.secondaryController && data.angle && prevData.angle) {
            localPlayerContainer.rotatePlatform(-(data.angle - prevData.angle), true);
            this.twoHandedGuestureView.update(data.primaryController.position, data.secondaryController.position, data.angle);
        }
    }
    end() {
        this.twoHandedGuestureView.reset();
    }
}
